<template>
  <div>
    <div class="jumbotron jumbotron-header">
      <div class="container">
        <h1 class="downloads-page-header"><i class="fa fa-download fa-3x header-downloads" aria-hidden="true"/>Your Recent Downloads</h1>
      </div>
    </div>
    <div class="container">
      <span v-if="!loaded" class="gb-text-2 text-muted"><i class="fa fa-circle-o-notch fa-spin fa-fw"/>Loading Recent Downloads...</span>
      <div class="row" v-if="loaded">
        <div class="col-md-12">
          <resource-preview-card
            v-for="res in resources"
            :key="res.uuid"
            :uuid="res.uuid"
            :title="res.title"
            :description="res.description"
            :type="res.type"
            :thumbnail_url="res.thumbnail_url"
            :grades="res.grades"
            :subjects="res.subjects"
            :download_links="res.download_links"
            :google_drive_links="res.google_drive_links"/>
        </div>
      </div>

      <submit-feedback type="RecentDownloads" />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { getUserDownloads } from '@/api/downloads'

import ResourcePreviewCard from '@/components/ResourcePreviewCard'
import SubmitFeedback from '@/components/SubmitFeedback'

export default {
  name: 'RecentDownloads',
  components: {
    ResourcePreviewCard,
    SubmitFeedback
  },
  data() {
    return {
      loaded: false,
      resources: []
    }
  },
  computed: {
    ...mapState({
      userUuid: state => state.user.user.uuid
    })
  },
  methods: {
    ...mapMutations('user', ['pushOnetimeCallback']),
    retrieveDownloads() {
      getUserDownloads({ full: true })
        .then(data => {
          this.loaded = true

          this.resources = (data.collection.content || [])
            .map(res => {
              return res.content_body
            })
            .slice(0, 25)
        })
        .catch(err => {
          console.error(err)
        })
    }
  },
  created: function() {
    if (this.userUuid) {
      this.retrieveDownloads()
    } else {
      this.pushOnetimeCallback(() => {
        this.retrieveDownloads()
      })
    }
    this.$sendEvent('Viewed Recent Downloads Page', { ref: this.$route.query.ref })
  }
}
</script>

<style lang="less">
@import '~@/variables.less';

.header-downloads {
  color:  @gb_blue_medium;
  font-size: 1em;
  margin-right: 16px;
}

.downloads-page-header {
  font-size: 56px;
}
</style>
